var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStart = function SvgStart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.639,
    height: 23.407,
    viewBox: "0 0 23.639 23.407",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1600",
    "data-name": "Group 1600",
    transform: "translate(17698.543 7748.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4256",
    "data-name": "Path 4256",
    d: "M633.6,257.9h22.528c.005.09.014.167.014.243q0,4.341,0,8.683a3.36,3.36,0,0,1-2.863,3.4,3.691,3.691,0,0,1-.632.038q-7.786,0-15.572,0a3.363,3.363,0,0,1-3.447-2.841,3.137,3.137,0,0,1-.038-.552q0-4.368,0-8.736C633.594,258.066,633.6,258,633.6,257.9Z",
    transform: "translate(-18331.572 -7995.87)",
    fill: "#e7e7eb",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4258",
    "data-name": "Path 4258",
    d: "M649.127,118.991c0-.711,0-1.4,0-2.1a1.721,1.721,0,0,1,.074-.518,1.122,1.122,0,0,1,2.179.342c.012.66,0,1.319,0,1.979,0,.095,0,.189,0,.312.385,0,.743,0,1.1,0a3.334,3.334,0,0,1,3.361,2.871,11.023,11.023,0,0,1,.012,1.616H633.291a14.223,14.223,0,0,1,.183-2,3.287,3.287,0,0,1,3.113-2.482c.412-.013.824,0,1.263,0,0-.347,0-.661,0-.976,0-.44-.008-.88,0-1.319a1.111,1.111,0,0,1,1.027-1.082,1.083,1.083,0,0,1,1.2.916,8.415,8.415,0,0,1,.035,1.079c.005.447,0,.895,0,1.36Z",
    transform: "translate(-18331.291 -7863.63)",
    fill: "#e7e7eb",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4257",
    "data-name": "Path 4257",
    d: "M747.179,304.316a.723.723,0,0,1-.734-.843c.082-.5.162-.992.245-1.488a.151.151,0,0,0-.045-.148c-.331-.336-.658-.676-.989-1.012a.729.729,0,0,1,.438-1.267c.443-.065.884-.142,1.327-.211a.151.151,0,0,0,.127-.1c.2-.422.4-.843.593-1.264a.722.722,0,0,1,1.332,0c.2.428.4.856.6,1.286a.134.134,0,0,0,.116.089c.469.069.938.141,1.406.217a.722.722,0,0,1,.409,1.2c-.342.359-.69.712-1.038,1.064a.169.169,0,0,0-.051.167c.079.488.155.977.225,1.467a.724.724,0,0,1-1.071.745q-.6-.327-1.2-.663a.147.147,0,0,0-.166,0c-.39.22-.783.435-1.174.652A.734.734,0,0,1,747.179,304.316Z",
    transform: "translate(-18435.51 -8032.716)",
    fill: "#b5b5c3"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/start.8940548b.svg";
export { ForwardRef as ReactComponent };